export default {
  GET_LEAD_TARGET: "GET_LEAD_TARGET",
  SAVE_CRM_SETTING_LEAD_FORM: "SAVE_CRM_SETTING_LEAD_FORM",
  SET_GATE_ITEM: "SET_GATE_ITEM",
  SAVE_CRM_GG_LEADS_SETTING: "SAVE_CRM_GG_LEADS_SETTING",
  SET_CRM_LOADING: "SET_CRM_LOADING",
  SET_VALIDATE_GATE: "SET_VALIDATE_GATE",
};
